module.exports = __webpack_public_path__ + "img/logo26.4ced8bee.svg";